import { Component } from '@angular/core';

import { DocumentBuilderPageDirective } from '../../../document-builder/document-builder-page.base.directive';

@Component({
    selector: 'la-pnc-risk-review-back',
    imports: [],
    styles: [
        `
      .back {
        background-color: var(--white);
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .back-container {
        width: 50%;
        text-align: center;
      }

      .back-small {
        font-size: 8pt;
      }

      .socials {
        display: flex;
        justify-content: center;
        margin-top: 1cm;
        gap: 0.5cm;
      }

      .social {
        width: 1.5cm;
        height: 1.5cm;
        background-color: var(--black);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: var(--white);

        & > svg {
          width: 0.8cm;
          height: 0.8cm;
        }
      }

      @media screen {
        .back {
          padding: 2cm;
        }
      }
    `,
    ],
    template: `
    <div class="doc-page doc-page-full back">
      <div class="back-container">
        <img
          src="/assets/ui/lockton_combined_black.svg"
          width="160"
          height="106"
        />
        <div class="back-small">
          <div class="fw-b"
            >Lockton Commercial is a trading name of Lockton Companies LLP</div
          >
          <div>
            Authorised and regulated by the Financial Conduct Authority
          </div>
          <div
            >The Clarence West Building, 2 Clarence Street West, Belfast, BT2
            7GP</div
          >
          <div>T: +44 (0)2890 248989</div>
        </div>
        <a
          href="https://global.lockton.com"
          class="text-decoration-underline fw-b mt-2"
          target="_blank"
          >global.lockton.com</a
        >

        <div class="socials">
          <a
            href="https://www.linkedin.com/company/lockton-companies/"
            class="social"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"
                fill="currentColor"
              />
            </svg>
          </a>
          <!-- <a href="" class="social">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                fill="currentColor"
              />
            </svg>
          </a> -->
          <a href="https://twitter.com/LocktonUK" class="social">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a href="https://vimeo.com/uklockton" class="social">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  `
})
export class PncRiskReviewBackComponent extends DocumentBuilderPageDirective {}
